export const STATUS_LABEL = {
  planned: 'Ikke tildelt', offered: 'Venter på svar', matched: 'Tildelt',
  in_progress: 'Pågår', completed: 'Fullført', cancelled: 'Kansellert',
};

// Tone for chip() i pages/carrier/carrierStyles.js
export const STATUS_TONE = {
  planned: 'none', offered: 'soon', matched: 'info', in_progress: 'info', completed: 'ok', cancelled: 'expired',
};

export const ORDER_TABS = [
  { key: 'planned', label: 'Ikke tildelt', statuses: ['planned'] },
  { key: 'offered', label: 'Venter på svar', statuses: ['offered'] },
  { key: 'active', label: 'Tildelt og pågår', statuses: ['matched', 'in_progress'] },
  { key: 'completed', label: 'Fullført', statuses: ['completed'] },
  { key: 'cancelled', label: 'Kansellert', statuses: ['cancelled'] },
];

export function ordersForTab(orders, tabKey) {
  const tab = ORDER_TABS.find((t) => t.key === tabKey);
  return tab ? orders.filter((o) => tab.statuses.includes(o.status)) : [];
}

export function countByTab(orders) {
  return Object.fromEntries(ORDER_TABS.map((t) => [t.key, orders.filter((o) => t.statuses.includes(o.status)).length]));
}

// Speiler endringsreglene på serveren (functions/src/carrierOrderValidation.js)
export const canEditFully = (status) => ['planned', 'offered', 'matched'].includes(status);
export const canReassign = (status) => ['planned', 'offered', 'matched'].includes(status);
export const canCancel = (status) => ['planned', 'offered', 'matched', 'in_progress'].includes(status);
